import { useProducts } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { MultiSelect } from '../../MultiSelect'

type Props = {
  name: string
}

export function ProductSelector(props: Props) {
  const { formatMessage } = useIntl()
  const { name } = props
  const [searchTerm, setSearchTerm] = useState('')

  const { data: products, isLoading } = useProducts({ searchTerm })

  return (
    <MultiSelect
      name={name}
      options={products?.items ?? []}
      label={formatMessage({
        id: 'admin/promotions.form.scope.products.select.placeholder',
      })}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
    />
  )
}
